const TwoFactorAuthAppStates = {
  DEFAULT: 'DEFAULT',
  BACKUP: 'BACKUP'
};
export default TwoFactorAuthAppStates;